import { Action } from 'redux';
import { IVpcConfiguration } from '@inter-ikea-kompis/types';
import { SummaryPageTab, VisibleModal, DesignSourceFromUrl } from 'sofa-reborn-react';

// State
export interface CheckoutState {
	vpcCode: string | null;
	savedVpcConfiguration: IVpcConfiguration | null;
	fetchVpcPending: boolean;
	showScreenshotSpinner: boolean;
	screenshot?: string | null;
	screenshotPending: boolean | null;
	vpcErrorMessage?: string | null;
	noSummaryPageBackButton: boolean;
	visibleModal: VisibleModal | null;
	designSource: DesignSourceFromUrl | null;
	upptackaSaveFail: boolean;
	twoSeparateSofas: boolean;
	showSummary: boolean;
	stockedIkeaPlus: boolean;
}

// Actions
export const SET_SCREENSHOT_SPINNER = 'SET_SCREENSHOT_SPINNER';
export const SCREENSHOT_PENDING = 'SCREENSHOT_PENDING';
export const SCREENSHOT_SUCCESS = 'SCREENSHOT_SUCCESS';

export const FETCH_VPC_PENDING = 'FETCH_VPC_PENDING';
export const FETCH_VPC_SUCCESS = 'FETCH_VPC_SUCCESS';
export const FETCH_VPC_FAILURE = 'FETCH_VPC_FAILURE';

export const YMAL_PIP_LINK_CLICK = 'YMAL_PIP_LINK_CLICK';
export const SUMMARY_PAGE_TAB_CLICK = 'SUMMARY_PAGE_TAB_CLICK';

export const SET_NO_SUMMARY_PAGE_BACK_BUTTON = 'SET_NO_SUMMARY_PAGE_BACK_BUTTON';
export const SET_VISIBLE_MODAL = 'SET_VISIBLE_MODAL';

export const SAVE_CONFIGURATION = 'SAVE_CONFIGURATION';
export const SET_SAVED_VPC_CONFIGURATION = 'SET_SAVED_VPC_CONFIGURATION';

export const SEND_SMS = 'SEND_SMS';
export const SEND_EMAIL = 'SEND_EMAIL';
export const COPY_CODE = 'COPY_CODE';
export const BACK_TO_SHARE_MENU = 'BACK_TO_SHARE_MENU';
export const SAVE_FOR_LATER_TAB_CLICK = 'SAVE_FOR_LATER_TAB_CLICK';
export const SET_DESIGN_SOURCE = 'SET_DESIGN_SOURCE';

export const SUMMARY_PAGE_EXPAND_PRODUCT = 'SUMMARY_PAGE_EXPAND_PRODUCT';
export const SHOW_ADD_TO = 'SHOW_ADD_TO';
export const SET_UPPTACKA_SAVE_FAIL = 'SET_UPPTACKA_SAVE_FAIL';

export const SORT_PRODUCT_LIST = 'SORT_PRODUCT_LIST';
export const SET_TWO_SEPARATE_SOFAS = 'SET_TWO_SEPARATE_SOFAS';

export const SET_SUMMARY_PAGE_DEFAULT_TAB = 'SET_SUMMARY_PAGE_DEFAULT_TAB';
export const SET_SHOW_SUMMARY = 'SET_SHOW_SUMMARY';

export const SET_STOCKED_IKEA_PLUS = 'SET_STOCKED_IKEA_PLUS';

interface FetchVpcPending extends Action {
	type: typeof FETCH_VPC_PENDING;
}

interface FetchVpcSuccess extends Action {
	type: typeof FETCH_VPC_SUCCESS;
	vpcCode: string | null;
}

interface FetchVpcFailure extends Action {
	type: typeof FETCH_VPC_FAILURE;
	message: string;
}

interface SetScreenshotSpinner extends Action {
	type: typeof SET_SCREENSHOT_SPINNER;
	value: boolean;
}

interface ScreenshotPending extends Action {
	type: typeof SCREENSHOT_PENDING;
}

interface ScreenshotSuccess extends Action {
	type: typeof SCREENSHOT_SUCCESS;
	data: string | null;
}

interface YmalPipLinkClick extends Action {
	type: typeof YMAL_PIP_LINK_CLICK;
	value: string;
}

interface SetNoSummaryPageBackButton extends Action {
	type: typeof SET_NO_SUMMARY_PAGE_BACK_BUTTON;
	value: boolean;
}

interface SummaryPageTabClick extends Action {
	type: typeof SUMMARY_PAGE_TAB_CLICK;
	value: SummaryPageTab;
}

interface SetVisibleModal extends Action {
	type: typeof SET_VISIBLE_MODAL;
	value: VisibleModal | null;
}

interface SaveConfiguration extends Action {
	type: typeof SAVE_CONFIGURATION;
}

interface SetSavedVpcConfiguration extends Action {
	type: typeof SET_SAVED_VPC_CONFIGURATION;
	value: IVpcConfiguration | null;
}

interface SendSms extends Action {
	type: typeof SEND_SMS;
}

interface SendEmail extends Action {
	type: typeof SEND_EMAIL;
}

interface CopyCode extends Action {
	type: typeof COPY_CODE;
}

interface BackToShareMenu extends Action {
	type: typeof BACK_TO_SHARE_MENU;
	value: string;
}

interface SaveForLaterTabClick extends Action {
	type: typeof SAVE_FOR_LATER_TAB_CLICK;
	value: string;
}

interface SetDesignSource extends Action {
	type: typeof SET_DESIGN_SOURCE;
	value: DesignSourceFromUrl;
}

interface SummaryPageExpandProduct extends Action {
	type: typeof SUMMARY_PAGE_EXPAND_PRODUCT;
	id: string;
	expand: boolean;
}

interface ShowAddTo extends Action {
	type: typeof SHOW_ADD_TO;
	value: { show: boolean; origin: string };
}

interface SetUpptackaSaveFail extends Action {
	type: typeof SET_UPPTACKA_SAVE_FAIL;
	value: boolean;
	error?: string;
}
interface SortProductList extends Action {
	type: typeof SORT_PRODUCT_LIST;
	value: string;
}

interface SetTwoSerarateSofas extends Action {
	type: typeof SET_TWO_SEPARATE_SOFAS;
	value: boolean;
}

interface SetSummarPageDefaultTab extends Action {
	type: typeof SET_SUMMARY_PAGE_DEFAULT_TAB;
	value: string;
}

interface SetShowSummary extends Action {
	type: typeof SET_SHOW_SUMMARY;
	value: boolean;
}

interface SetStockedIkeaPlus extends Action {
	type: typeof SET_STOCKED_IKEA_PLUS;
	value: boolean;
}

export type CheckoutStateActions =
	| FetchVpcPending
	| FetchVpcSuccess
	| FetchVpcFailure
	| SetScreenshotSpinner
	| ScreenshotPending
	| ScreenshotSuccess
	| YmalPipLinkClick
	| SetNoSummaryPageBackButton
	| SummaryPageTabClick
	| SetVisibleModal
	| SaveConfiguration
	| SetSavedVpcConfiguration
	| SendSms
	| SendEmail
	| CopyCode
	| BackToShareMenu
	| SaveForLaterTabClick
	| SetDesignSource
	| SummaryPageExpandProduct
	| ShowAddTo
	| SetUpptackaSaveFail
	| SortProductList
	| SetTwoSerarateSofas
	| SetSummarPageDefaultTab
	| SetShowSummary
	| SetStockedIkeaPlus;
